import { render, staticRenderFns } from "./courseAct.vue?vue&type=template&id=ff13d774&scoped=true&"
import script from "./courseAct.vue?vue&type=script&lang=js&"
export * from "./courseAct.vue?vue&type=script&lang=js&"
import style0 from "./courseAct.vue?vue&type=style&index=0&id=ff13d774&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff13d774",
  null
  
)

export default component.exports